/* tslint:disable:no-submodule-imports */
export * from "theme/styledComponents";
export { default } from "theme/styledComponents";
